var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { TiChevronLeftOutline, TiChevronRightOutline } from "react-icons/ti";
import "./RecCarousel.scss";
var MAX_VISIBILITY = 3;
var Card = function (_a) {
    var title = _a.title, content = _a.content, onClick = _a.onClick;
    return (_jsxs("div", __assign({ className: "card", onClick: onClick, style: { cursor: onClick ? 'pointer' : 'default' } }, { children: [_jsx("h2", { children: title }), _jsx("div", { children: content })] })));
};
var Carousel = function (_a) {
    var children = _a.children;
    var _b = useState(0), active = _b[0], setActive = _b[1];
    var count = React.Children.count(children);
    return (_jsxs("div", __assign({ className: "carousel" }, { children: [active > 0 && (_jsx("button", __assign({ className: "nav left", onClick: function () { return setActive(function (i) { return i - 1; }); } }, { children: _jsx(TiChevronLeftOutline, {}) }))), React.Children.map(children, function (child, i) {
                return (_jsx("div", __assign({ className: "card-container", style: {
                        "--active": i === active ? 1 : 0,
                        "--offset": (active - i) / 3,
                        "--direction": Math.sign(active - i),
                        "--abs-offset": Math.abs(active - i) / 3,
                        pointerEvents: active === i ? "auto" : "none",
                        opacity: Math.abs(active - i) >= MAX_VISIBILITY ? "0" : "1",
                        display: Math.abs(active - i) > MAX_VISIBILITY ? "none" : "block",
                    } }, { children: child })));
            }), active < count - 1 && (_jsx("button", __assign({ className: "nav right", onClick: function () { return setActive(function (i) { return i + 1; }); } }, { children: _jsx(TiChevronRightOutline, {}) })))] })));
};
var RecCarousel = function (_a) {
    var items = _a.items;
    return (_jsx("div", __assign({ className: "app" }, { children: _jsx(Carousel, { children: items.map(function (item, i) { return (_jsx(Card, { title: item.title, content: item.content, onClick: item.onClick }, i)); }) }) })));
};
export default RecCarousel;
